import { ThemeProvider } from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import { AllStakingPools } from "./components/AllStakingPools";
import { ContactUs } from "./components/ContactUs";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { UserAgreement } from "./components/UserAgreement";
import { theme } from "./material-ui-theme";
import { MainLayout } from "./pages/MainLayout";
import { Staking } from "./pages/Staking";
import { Wallet } from "./pages/Wallet";
import { Web3 } from "./pages/Web3";
import { Appchain } from "./pages/Appchain";
import { Stakeshot } from "./pages/Stakeshot"

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <div className="App">
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route path="/" element={<Staking />} />

            <Route path="/stakingPools" element={<AllStakingPools />} />

            <Route path="/wallet" element={<Wallet />} />

            <Route path="/web3" element={<Web3 />} />
            <Route path="/contactUs" element={<ContactUs />} />
            <Route path="/appchain" element={<Appchain />} />

            
            <Route path="/stakeshot" element={<Stakeshot />} />
            <Route path="/privacyPolicy" element={<PrivacyPolicy />} />

            <Route path="/userAgreement" element={<UserAgreement />} />

            <Route path="/" element={<Navigate replace to="/" />} />
          </Route>

          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
      </div>
    </ThemeProvider>
  );
}

export default App;
